<!-- 
    描述：系统通知 --- 浏览记录
    时间：2021/05/18
    Created by zl
-->
<template>
	<div class="BrowsingHistory-layout primary-layout">
		<div class="primary-header">
			<div class="left-text">
				<span> 通知标题：{{ title }}</span>
			</div>
			<div class="btnGroups">
				<el-input v-model="searchName"
						  placeholder="请输入账号"
						  size="small"
						  @keyup.enter.native="getData"
						  class="w300">
					<template slot="append">
						<el-button type="primary"
								   @click="getData">查询</el-button>
					</template>
				</el-input>
				<el-button type="success"
						   size="small"
						   class="btn-success ml10"
						   icon="el-icon-refresh"
						   @click="getData('refresh')"></el-button>
			</div>
		</div>
		<div class="primary-content w-table-layout">
			<div class="w-table-content">
				<vxe-table align="center"
						   border
						   :data="historyData"
						   :loading="loading"
						   height="100%"
						   show-header-overflow="tooltip"
						   show-overflow="tooltip"
						   highlight-current-row
						   highlight-hover-row>
					<vxe-table-column type="seq"
									  width="70px"
									  title="序号"></vxe-table-column>
					<vxe-table-column field="createUserid"
									  title="已浏览用户ID"></vxe-table-column>
					<vxe-table-column field="userName"
									  title="账号"></vxe-table-column>
					<vxe-table-column field="createDate"
									  title="浏览时间"></vxe-table-column>
					<vxe-table-column title="访问业务端">
						<template v-slot="{ row }">审计管理系统</template>
					</vxe-table-column>
				</vxe-table>
			</div>
		</div>
	</div>
</template>
<script>
import * as API from 'api/noticeManager/index'
export default {
	name: 'BrowsingHistory',
	components: {},
	props: {},
	data() {
		return {
			searchName: '', //搜索
			historyData: [], //浏览历史数据
			loading: false,
			title: '', //通知标题
		}
	},
	created() {
		if (!this.$route.params.obj) {
			this.backHome()
			return
		}
		this.title = this.$route.params.obj.sname
		this.getData()
	},
	methods: {
		// 获取数据
		getData(type) {
			if (type == 'refresh') {
				this.searchName = ''
			}
			this.loading = true
			API.readNoticeReadInfo({
				noticeId: this.$route.params.obj.id,
				userName: this.searchName,
			})
				.then((res) => {
					this.historyData = res.data
					this.loading = false
				})
				.catch(() => {
					this.loading = false
				})
		},

		// 返回
		backHome() {
			this.$router.push({
				name: 'NotificationManager',
			})
		},
	},
	computed: {},
}
</script>
<style lang='less' scoped>
.BrowsingHistory-layout {
	padding: 20px !important;
	.left-text {
		padding-left: 10px;
		border-left: 4px solid #60adf9;
		span {
			font-size: 16px !important;
		}
	}
	.w300 {
		/deep/ .el-input__inner {
			width: 300px !important;
		}
		.el-button {
			height: 32px !important;
			padding: 9px 20px;
		}
	}
}
</style>
